import * as Yup from "yup";

const saleLotValidation = Yup.object({
  buyer_id: Yup.string()
    .nullable()
    .when("unit_price", {
      is: (unitPrice: unknown) => !!unitPrice,
      then: s => s.required("Buyer is required when a price is set"),
    }),
  quantity: Yup.number()
    .typeError("Head count is required")
    .integer("Must be a whole number")
    .min(1, "Must be at least 1")
    .required("Head count is required"),
  product_id: Yup.string().nullable(),
  sex_id: Yup.number().nullable(),
  age_id: Yup.number().nullable(),
  breed_id: Yup.number().nullable(),
  quantity_progeny: Yup.number().nullable().integer().min(0),
  dentitionId: Yup.number().nullable(),
  exemption_id: Yup.number().nullable(),
  category_id: Yup.number().nullable(),
  note: Yup.string(),
  pricing_type_id: Yup.number().nullable().required("Pricing type is required"),
  unit_price: Yup.number().nullable(),
});

export const validationSchema = Yup.object({
  sale: Yup.object({
    date: Yup.string().required("Sale date is required"),
  }),
  consignment: Yup.object({
    vendor_id: Yup.string().nullable(),
  }),
  saleLot: saleLotValidation,
});
